import axios from './BaseService';

const SETTINGS_URL = `${
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL
}/settings`;

export async function getSettings() {
    const response = await axios.get(SETTINGS_URL);
    return response.data;
}

export async function updateSettings(settings) {
    const response = await axios.patch(SETTINGS_URL, settings);
    return response.data;
}

export async function testSmtp(settings) {
    const { smtpHost, smtpPort, smtpUser, smtpPass } = settings;
    const response = await axios.post(`${SETTINGS_URL}/smtp/test`, {
        smtpHost,
        smtpPort,
        smtpUser,
        smtpPass,
    });
    return response.data;
}

// Tests an accessKey/secretKey (spot) or futuresKey/futuresSecret (futures,
// isFuture=true) pair against Binance without saving anything. Falls back to
// the already saved key on the backend when the field is empty or masked.
export async function testApiKey(settings, isFuture) {
    const { accessKey, secretKey, futuresKey, futuresSecret } = settings;
    const response = await axios.post(`${SETTINGS_URL}/key/test`, {
        isFuture,
        accessKey,
        secretKey,
        futuresKey,
        futuresSecret,
    });
    return response.data;
}
